export const getLocale = state => state.config.locale;
export const getBaseUrl = () => 'https://swapi.co/api';
